import { createPopper } from '@popperjs/core';
import Bootstrap from 'bootstrap';
import { Fancybox } from "@fancyapps/ui";


// Silence is gold
import "%modules%/sections-carousel/sections-carousel.js";
import "%modules%/main-slider/main-slider.js";
import "%modules%/catalog-detail/catalog-detail.js";
import "%modules%/catalog-section/catalog-section.js";
import "%modules%/favorites/favorites.js";
import "%modules%/burger/burger.js";
import "%modules%/search-form/search-form.js";
import "%modules%/basket/basket.js";